<template>
  <div>
    <h4 v-if="header">
      {{ header }}
    </h4>
    <div v-if="datacollection" class="vacancy-stat">
      <VacancyPolarAreaChart
        :chart-data="datacollection"
        :height="150"
      ></VacancyPolarAreaChart>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";
import VacancyPolarAreaChart from "./VacancyPolarAreaChart";

export default {
  components: {
    VacancyPolarAreaChart
  },
  props: {
    numbers: { type: Array, required: true },
    metric: { type: String, required: true },
    header: { type: String }
  },
  data() {
    return {
      datacollection: null
    };
  },
  apollo: {
    biStats: {
      query: gql`
        query BiStats($filter: BIStatsFilter!) {
          biStats(filter: $filter) {
            interval
            numDatapoints
            datapoints {
              time
              interval
              amount
              type
              info {
                source {
                  id
                  name
                }
              }
            }
          }
        }
      `,
      variables() {
        return {
          filter: {
            vacancyNumber: this.numbers,
            interval: 10080,
            grouping: "SOURCE",
            fromTime: moment()
              .startOf(6, "days")
              .startOf("week"),
            toTime: moment()
              .startOf(6, "days")
              .endOf("week"),
            metrics: [this.metric]
          }
        };
      }
    }
  },
  watch: {
    numbers() {},
    biStats(stats) {
      if (!stats.datapoints) {
        this.datacollection = null;
        return;
      }

      stats.datapoints.sort((a, b) =>
        a.time > b.time ? 1 : a.time < b.time ? -1 : 0
      );

      let labels = [];
      for (let data of stats.datapoints) {
        let title = "Sonstige";
        if (data.info && data.info.source) {
          title = `${data.info.source.name}`;
        }

        if (labels.findIndex(val => val === title) === -1) {
          labels.push(title);
        }
      }

      let ChartData = [];

      for (let label of labels) {
        let dataAmount = 0;
        for (let data of stats.datapoints) {
          let title = "Sonstige";
          if (data.info && data.info.source) {
            title = `${data.info.source.name}`;
          }

          if (label === title) {
            dataAmount = data.amount;
          }
        }

        ChartData.push(dataAmount);
      }

      this.datacollection = {
        labels,
        datasets: [
          {
            label: "Besucher (eindeutig)",
            data: ChartData,
            fill: true,
            backgroundColor: [
              "#13358e",
              "#48c6ef",
              "#55c400",
              "#d1232b",
              "#2e5573",
              "#48a600"
            ],
            pointHoverBackgroundColor: "#000000",
            lineTension: 0
          }
        ]
      };
    }
  }
};
</script>
